import { useState } from 'react';
import { useCheckPaymentExpiration } from '~/domain/Payments';
import history from '~/browserHistory';
import { routes } from '~/routes';
import { Alert } from '@tempmee/react';
import { OutlineWarning01Icon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import { ConfirmPopup } from '~/commonComponents';

interface IPaymentWarningBannerProps {
  officeId?: string;
  containerStyle?: React.CSSProperties;
}

export const PaymentWarningBanner = ({ officeId, containerStyle }: IPaymentWarningBannerProps) => {
  const [showAddPaymentPopup, setShowAddPaymentPopup] = useState(false);
  const { isInvalidPayment } = useCheckPaymentExpiration(officeId);

  if (!isInvalidPayment) {
    return null;
  }

  return (
    <>
      <Alert
        severity="error"
        onClick={() => setShowAddPaymentPopup(true)}
        style={containerStyle}
        description="Your payment method is either missing or expired. Please update it to unlock candidate names and send invites to professionals."
      />

      {showAddPaymentPopup && (
        <ConfirmPopup
          title="Payment Method Missing or Expired"
          description="In order to invite a professional, please add or update your preferred payment method."
          leftButtonText="Go Back"
          leftButtonAction={() => setShowAddPaymentPopup(false)}
          rightButtonText="Add Payment"
          rightButtonAction={() => {
            setShowAddPaymentPopup(false);
            history.push(routes.paymentInformation);
          }}
          closePopup={() => setShowAddPaymentPopup(false)}
          Icon={() => <OutlineWarning01Icon color={colors.warning[500]} />}
        />
      )}
    </>
  );
};
